import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import type { AxiosError, AxiosResponse } from "axios"
import type { UpdateTmaisBannerValidationSchema } from "../schemas/update.schema"
import { toIsoFromDateTimeParts } from '@/common/utils/dateUtils';

type UseUpdateTmaisBannerProps = {
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: AxiosError) => void
}

export const useUpdateTmaisBanner = ({ onSuccess, onError }: UseUpdateTmaisBannerProps = {}) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ["updateTmaisBanner"],
    mutationFn: async ({ id, form }: { id: string; form: UpdateTmaisBannerValidationSchema }) => {
      const bannerPayload: Record<string, any> = {
        title: form.title,
        description: form.description,
        mobile_redirect_to: form.mobile_redirect_to,
        active_at: toIsoFromDateTimeParts(form.active_at_date, form.active_at_time),
      };

      if (form.add_expiration && form.expires_at_date && form.expires_at_time) {
        bannerPayload.expires_at = toIsoFromDateTimeParts(form.expires_at_date, form.expires_at_time);
      } else {
        bannerPayload.expires_at = ""; 
      }
      if (form.file instanceof File) {
        bannerPayload.file = form.file;
      }
      return await privateAxios.putForm(`/tmais/banners/${id}`, {
        banner: bannerPayload
      });
    },
    onSuccess: (res) => {
      onSuccess?.(res)
    },
    onError,
  })
}
